import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorService, AppError } from '../../services/error.service';

@Component({
  selector: 'app-error-boundary',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './error-boundary.component.html',
  styleUrls: ['./error-boundary.component.scss']
})
export class ErrorBoundaryComponent  {
 constructor(private errorService: ErrorService) {}

  get errors$() {
    return this.errorService.errors;
  }

  dismiss(id: string): void {
    this.errorService.dismissError(id);
  }

  retry(id: string): void {
    this.errorService.retry(id);
  }

  getIcon(type: string): string {
    const icons: { [key: string]: string } = {
      error: '❌',
      warning: '⚠️',
      info: 'ℹ️',
      success: '✅',
    };
    return icons[type] || 'ℹ️';
  }
}
